import React from "react";

import Button from "../Button";
import Collapsible from "react-collapsible";
import Border from "../Border";
import Dropdown from "../Dropdown";
import AddProduct from "../AddProduct";

import { getImageUrl, Sizes } from "./editable/Img";
import Section from "./editable/Section";

import ProductVariantsModal from "./../modal/ProductVariantsModal";

import ScriptCache from "../../utils/ScriptCache";
import General from "../../utils/General";
import Backend from "../../utils/Backend";
import Currency from "../../utils/Currency";
import Cart from "../../utils/Cart";
import Event from "../../utils/Event";
import AsyncSelect from "../common/CCAsyncSelect";
import Navigation from "../../utils/Navigation";
import BadgeBlock from "../BadgeBlock";
import LayoutEditor from "../LayoutEditor";
import ProductDetail from "../ProductDetail";
import Toggle from "../sectioninputs/Toggle";
import PortalModal from "../modal/PortalModal";
import IconPickerGrid from "../IconPickerGrid";
import ProductDetailSettings from "../ProductDetailSettings";
import DefaultData from "../../utils/DefaultData";

import Block from "./Block";


export default class Block37 extends Block {
  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      data: props.data,
      editable: props.editable,
      products: [],
      quantity: 1,
      variant: [],
      featuredProduct: null,
      purchaseOption: "single",
      uuid: "cb_"+General.uuid(),
      subscribeAndSaveSettings: props.data?.extra?.subscribe_save_settings || {
        textColor: 'rgb(102, 102, 102)',
        selectedTextColor: 'rgb(102, 102, 102)',
        backgroundColor: 'rgb(252, 252, 252)',
        selectedBackgroundColor: 'rgb(252, 252, 252)',
        borderColor: 'rgb(236, 236, 236)',
        selectedBorderColor: 'rgb(236, 236, 236)',
        borderStyle: '6px',
        oneTimeIcon: '',
        subscribeIcon: '',
        activeIconTab: 'subscribe',
        discountFormat: 'price',
        useCustomIcon: false,
      }
    };

  }

  componentDidMount() {
    this._setUp()
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps, () => this._setUp());
  }

  _setUp(){
    let{
      data,
      featuredProduct
    } = this.state

    if(!featuredProduct && data.extra?.featured_product){
      this._loadProduct(data.extra?.featured_product.productId)
    }
  }

  _loadProduct(productId){
    this.setState({ loading: true })
    Backend.getProducts(productId).then(products => {
      let featuredProduct = products[0]
      let variant = Cart.selectDefaultVariant(featuredProduct)
      let variantOptions = Cart.getOptions(featuredProduct)
      let customMessageOptions = Cart.getCustomMessageOptions(featuredProduct)
      let purchaseOption = featuredProduct.defaultProduct === 'RECURRING' ? 'recurring' : 'single'
      if(featuredProduct.recurringProductId){
        Backend.getProducts(featuredProduct.recurringProductId).then(subscribeAndSaveProducts => {
          let subscribeAndSaveProduct = subscribeAndSaveProducts[0]
          let subscribeAndSaveVariantOptions = Cart.getOptions(subscribeAndSaveProduct)
          this.setState({customMessageOptions, variant, variantOptions, featuredProduct, purchaseOption, loading: false, subscribeAndSaveProduct, subscribeAndSaveVariantOptions}, () => this._loadJs())
        })
      }else{
        this.setState({variant, variantOptions, featuredProduct, customMessageOptions, purchaseOption, loading: false}, () => this._loadJs())
      }
    })
  }

  _loadJs() {
    General.updateSlides()
  }

  _renderPrice(product) {
    let { data } = this.state;

    if (!product) {
      return "";
    }

    let price = product.cycle1_price
    const compareAtPrice = product.compareAtPrice

    if (product.on_sale) {
      return (
        <>
          <span
            className="h3 type--strikethrough m-0 pr-1"
            style={{ color: data.settings.secondary_color }}
          >
            {Currency.toFormat(price)}
          </span>
          <span
            className="h3 m-0 pr-2"
            style={{ color: data.settings.secondary_color }}
          >
            {Currency.toFormat(price)}
          </span>
        </>
      );
    }

    if(product.variants.length > 0){
      if(product.variants[0].price){
        price = product.variants[0].price
      }
    }

    return (
      <>
        {compareAtPrice > 0 && <span
            className="h3 type--strikethrough m-0 pr-1"
            style={{ color: data.settings.secondary_color }}
        >
          {Currency.toFormat(compareAtPrice)}
        </span>}
        <span
          className="h3 m-0 pr-2"
          style={{ color: data.settings.secondary_color }}
        >
          {Currency.toFormat(price)}
        </span>
      </>
    );
  }

  _update(data, callback) {
    this.setState({ ...data }, () => {
      if (callback) {
        callback();
      }
      this.updateContentBlock();
    });
  }

  updateSubscribeAndSaveSettings = (keyOrObject, value) => {
    this.setState(prev => {
      const { data } = this.state;
      const updatedSettings = {
        ...prev.subscribeAndSaveSettings,
        ...(typeof keyOrObject === 'object'
          ? keyOrObject
          : { [keyOrObject]: value })
      };
      if(!data.extra){
        data.extra = {subscribe_save_settings: null}
      }
      data.extra.subscribe_save_settings = updatedSettings;
      this._update(data)
      return { subscribeAndSaveSettings: updatedSettings };
    });
  };

  _getProductOption(product){
    if(!product){
      return null
    }

    return {
      label: product.productName,
      value: product.productId,
      data: product
    }
  }

  _getModalContent(data) {
    let {
      subscribeAndSaveSettings
    } = this.state;

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data.extra?.[key] === "img_tile") {
        imgTileVariantType = key
      }
    })

    const productDetailSettings = data.extra || {
      color_picker_style: "square",
      variant1_style: "btn_horizontal",
      variant2_style: "btn_horizontal",
      variant3_style: "btn_horizontal",
      meta_field_type: "tabs",
      collapsible_list_open_icon: "fa-plus fas",
      collapsible_list_close_icon: "fa-minus fas",
      collapsible_list_toggle: true,
      column_width: "standard",
      img_tile_position: "right",
      img_only_aspect_ratio: "default",
      display_variant_tile_price: false,
      autoplay_carousel_toggle: false,
      showResetLayoutModal: false,
    }

    return (
      <>
        <Border>
          <Collapsible trigger="Variation">
            <br></br>

            <select
              value={data.variation || "featured_product"}
              onChange={(event) => {
                data.variation = event.target.value;

                this._update({
                  data,
                  key: this.state.key + 1,
                }, () => {
                  General.updateSlides()
                });
              }}
            >
              <option value="featured_product">Featured Product</option>
              <option value="product_detail">Product Detail</option>
            </select>
          </Collapsible>
        </Border>
        <Border>
          <Collapsible trigger="Select Product">
            <br />
            <AsyncSelect
              endpoint={window.CCApi.Products}
              classNamePrefix="async-select-paginate"
              placeholder="Please Select A Product"
              noOptionsMessage={() => "No Products Found"}
              value={this._getProductOption(data.extra?.featured_product)}
              onSelected={product => {
                if(!data.extra) {
                  data.extra = {featured_product: product}
                }else {
                  data.extra.featured_product = product;
                }
                this.setState({ data }, () => this._loadProduct(product.productId))
                this._update({
                  data,
                  key: this.state.key + 1,
                }, () => {
                  General.updateSlides()
                })
              }}
              getOptions={options => options.map(option => this._getProductOption(option[1]))}
            />
          </Collapsible>
        </Border>

        {
          data.variation === "product_detail" &&
          <>
            <ProductDetailSettings
              data={productDetailSettings}
              subscribeAndSaveSettings={subscribeAndSaveSettings}
              onUpdated={(extra) => {
                data.extra = {...extra}
                this.setState({
                  data
                }, () => {
                  this._update({
                    data,
                    key: this.state.key + 1,
                  }, () => {
                    General.updateSlides()
                  })
                })
              }}
              updateSubscribeAndSaveSettings={this.updateSubscribeAndSaveSettings}
            />
          </>
        }
      </>
    );
  }

  _renderFeaturedProduct() {
    let {data, quantity, featuredProduct, variantOptions, key, customMessageOptions} = this.state;

    let images = [{original: featuredProduct?.imageUrl}]

    let showAddCart = (variantOptions && Object.entries(variantOptions).length < 1) && (customMessageOptions && customMessageOptions.length < 1)

    let cartButtonText = "Add To Cart"

    const checkoutType = window.CURRENT_WEBSITE.checkout_type;
    if(checkoutType === "instant"){
      cartButtonText = "Buy Now"
    }
    const isBoth = (checkoutType === "instantAndCart") || (checkoutType === "instantAndBuy");
    const productUrl = Navigation.getProductUrl(featuredProduct.campaignProductId);
    return (
      <>
        <div className="row justify-content-around flex-wrap-reverse">
          {/* starts, column right  */}
          <div className="col-md-5 col-lg-5">
            <h2 style={{ color: data.settings.primary_color }}>
              {featuredProduct.productName}
            </h2>
            <div className="text-block d-flex align-items-center pb-3">
              {this._renderPrice(featuredProduct)}
              {featuredProduct.on_sale && (
                <span className="label position-static product-sale-price">
                  Sale
                </span>
              )}
            </div>
            <div
              className="lead pre"
              style={{ color: data.settings.secondary_color }}
              dangerouslySetInnerHTML={{
                __html: featuredProduct.productDescription,
              }}
            />
            <div>
              {
                showAddCart ?
                  <>
                    {!isBoth && (
                      <a
                        className="btn btn--primary mb-2 w-100"
                        onClick={() =>this.props.onAddToCartPressed(featuredProduct, null, [], quantity)}
                      >
                        <span className="btn__text">
                          {cartButtonText}
                        </span>
                      </a>
                    )}
                    {isBoth && (
                      <div className="row gx-2 mb-2">
                        <div className="col-12 col-md-6 mb-2 mb-md-0">
                          <a
                            className="btn btn--primary w-100"
                            onClick={() => {
                              window.CURRENT_WEBSITE.checkout_type = "instantAndCart";
                              this.props.onAddToCartPressed(featuredProduct, null, [], quantity)}
                            }
                          >
                            <span className="btn__text">Add To Cart</span>
                          </a>
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                          <a
                            className="btn btn--secondary w-100"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              window.CURRENT_WEBSITE.checkout_type = "instantAndBuy";
                              this.props.onAddToCartPressed(featuredProduct, null, [], quantity);
                            }}
                          >
                            <span className="btn__text">Buy Now</span>
                          </a>
                        </div>
                      </div>
                    )}
                  </>
                  :
                  <a
                    className="btn btn--primary mb-2 w-100"
                    href={productUrl}
                    onClick={() => {
                      General.setLocationHref(productUrl)
                    }}
                  >
                    <span className="btn__text">More Details</span>
                  </a>
              }
            </div>
          </div>
          <div className="col-md-7 col-lg-6">
            <div className="position-relative">
              <div
                key={key}
                className="slider border--round boxed--border"
                data-paging="true"
                data-arrows="true"
              >
                <ul className="slides">
                  {images.map((image) => {
                    return (
                      <li
                        key={image.id}
                        style={{
                          backgroundImage:
                            "url(" + getImageUrl(image, 37) + ")",
                        }}
                        priority={this.props.index}
                      ></li>
                    );
                  })}
                </ul>
              </div>
              <BadgeBlock product={featuredProduct} />
            </div>
          </div>
        </div>
      </>
    )
  }

  _renderProductDetail() {
    let {
      editable,
      data,
      key,
      loading,
      featuredProduct,
      variant,
      variantOptions,
      subscribeAndSaveProduct,
      subscribeAndSaveVariantOptions,
      subscribeAndSaveSettings,
      customMessageOptions,
      purchaseOption
    } = this.state;

    const evenColumnWidth = data.extra?.column_width === "even"
    let layoutOrder = data.extra?.layoutOrder;
    if (!layoutOrder || !Array.isArray(layoutOrder) || layoutOrder.length === 0) {
      layoutOrder = [...DefaultData.PRODUCT_PAGE_LAYOUT];
    }

    return (
      <>
        <ProductDetail
          key={key}
          product={featuredProduct}
          variant={variant}
          purchaseOption={purchaseOption}
          variantOptions={variantOptions}
          subscribeAndSaveProduct={subscribeAndSaveProduct}
          subscribeAndSaveVariantOptions={subscribeAndSaveVariantOptions}
          customMessageOptions={customMessageOptions}
          subscribeAndSaveSettings={subscribeAndSaveSettings}
          editable={editable}
          extra={data.extra}
          evenColumnWidth={evenColumnWidth}
          layoutOrder={layoutOrder}
          onAddToCartPressed={(
            product,
            variant = null,
            customMessage =null,
            quantity = 1,
            frequency = null
          ) => {
            this.props.onAddToCartPressed(product, variant, customMessage, quantity, frequency);
          }}
        />
      </>
    )
  }

  render() {
    let { data, loading, editable, variant, quantity, featuredProduct, variantOptions, key, showProductVariantsModal, customMessageOptions, uuid } = this.state;

    if (!editable && (!featuredProduct)) {
      return null;
    }

    return (
      <Section
        data={data}
        index={this.props.index}
        className={`block-37 space--lg switchable page product mb-0 ${data.variation === "featured_product" ? "featured-product" : "product-detail"}`}
        primaryColor={false}
        secondaryColor={false}
        editable={editable}
        onUpdated={(data) => this._update({ data })}
        onDelete={() => this.props.onDelete()}
        onAddContentBlockPressed={(contentBlock) =>
          this.props.onAddContentBlockPressed(contentBlock)
        }
        renderModalContent={() => this._getModalContent(data)}
        canMoveUp={this.props.canMoveUp}
        canMoveDown={this.props.canMoveDown}
        onVisibilityButtonPressed={(index) => this.props.onVisibilityButtonPressed(index)}
        onMoveUpPressed={() => this.props.onMoveUpPressed()}
        onMoveDownPressed={() => this.props.onMoveDownPressed()}
        onVisibilityToggled={() => this.props.onVisibilityToggled()}
      >
        <div className="container" id={uuid}>
          {((featuredProduct == null) && !loading) && (
            <AddProduct />
          )}
          {(featuredProduct && (!data.variation || data.variation === "featured_product")) && this._renderFeaturedProduct()}
          {(featuredProduct && data.variation === "product_detail") && this._renderProductDetail()}
        </div>
        {
          showProductVariantsModal &&
          <ProductVariantsModal
            show={showProductVariantsModal}
            product={featuredProduct}
            variantOptions={variantOptions}
            onSelected={(product, productVariant) => {
              this.setState({ showProductVariantsModal: false });
              this.props.onAddToCartPressed(featuredProduct, productVariant, quantity);
            }}
            onHide={() => this.setState({ showProductVariantsModal: false })}
          />
        }
      </Section>
    );
  }
}
